module.exports = __webpack_public_path__ + "assets/2773cb70acb270fe637800ad941a6d74.svg";